export function About() {
  document.title = "เกี่ยวกับเรา — Lucky News";
  return (
    <div className="max-w-2xl space-y-4">
      <h1 className="font-display text-3xl">เกี่ยวกับเรา</h1>
      <p className="text-foreground/80">
        Lucky News คือบล็อกดูดวงภาษาไทยที่ตั้งใจสร้างประสบการณ์การอ่านที่สวยงาม อ่านง่าย และมีสาระ
        ทั้งดวงรายวัน เคล็ดลับเสริมดวง และเครื่องมือเช็กความเข้ากันได้
      </p>
      <p className="text-foreground/80">
        ติดตามเราได้ที่ luckynews.co และสมัครจดหมายข่าวเพื่อรับอัปเดตประจำสัปดาห์
      </p>
    </div>
  );
}

export default About;
